/* eslint-disable func-names,arrow-body-style  */

import _ from 'lodash';
import { call, put, takeLatest, select, takeEvery } from 'redux-saga/effects';
import { MAX_WEIGHT } from '../../appConstants';
import VocabularyListTermObject from './../models/VocabularyListTermObject';

import {
  VOCABULARY_LIST_DRILLDOWN_FETCH_TERM,
  VOCABULARY_LIST_DRILLDOWN_SET_CURRENT_VOCABULARY_NAME,
  VOCABULARY_LIST_DRILLDOWN_SET_CURRENT_VOCABULARY_TERMS,
  VOCABULARY_LIST_DRILLDOWN_VOCABULARY_STATE_LOADED,
  VOCABULARY_LIST_DRILLDOWN_EDITING_SET_IS_EDITING_VOCABULARY,
  VOCABULARY_LIST_DRILLDOWN_EDITING_SAVE,
  VOCABULARY_LIST_DRILLDOWN_DELETE_CHECKED_TERMS,
  VOCABULARY_LIST_DRILLDOWN_SET_VOCABULARY_STATE_LOADING,
  VOCABULARY_LIST_DRILLDOWN_SET_VOCABULARY_STATE_LOADED,
  VOCABULARY_LIST_DRILLDOWN_SET_VOCABULARY_STATE_LOAD_ERROR,
  VOCABULARY_LIST_DRILLDOWN_ADDING_VOCABULARY_RESET,
  VOCABULARY_LIST_DRILLDOWN_STOP_ADDING_VOCABULARY,
  VOCABULARY_LIST_DRILLDOWN_ADD_NEW_VOCABULARY,
  VOCABULARY_LIST_DRILLDOWN_EDITING_DESTROY,
  VOCABULARY_LIST_DRILLDOWN_EDITING_SET_CURRENT_TERM_CHECKLIST,
  VOCABULARY_LIST_DRILLDOWN_SET_EDIT_VOCABULARY_WEIGHT,
} from './terminusDrilldownConstants';

import {
  MODEL_CUSTOM_VOCABULARY_ADD_RECORD,
  MODEL_CUSTOM_VOCABULARY_IDENTITY,
  MODEL_CUSTOM_VOCABULARY_SET_RECORDS,
  MODEL_CUSTOM_VOCABULARY_REMOVE_RECORD,
} from '../models/CustomVocabulary/customVocabularyConstants';

import {
  customVocabularyAddRecord,
  customVocabularyUpdateRecord,
  customVocabularyRemoveRecords,
  customVocabularyFetchRecord,
} from '../models/CustomVocabulary';

import { providers } from './terminusDrilldownReducers';

export default (bottle) => {
  bottle.factory('terminusDrilldownHandlerFetchTerm', () => {
    return function* fetchTerm() {
      yield put({ type: VOCABULARY_LIST_DRILLDOWN_SET_VOCABULARY_STATE_LOADING });
      const [vocabularyName, token] = yield select((state) => {
        return [
          _.get(state, 'terminusDrilldown.vocabularyName'),
          _.get(state, 'users.ephemeralKey.bearerToken'),
        ];
      });
      if (!vocabularyName) {
        return;
      }
      if (!token) {
        yield put({ type: VOCABULARY_LIST_DRILLDOWN_SET_VOCABULARY_STATE_LOAD_ERROR });
        return;
      }

      yield put(providers.setEditingTermName(vocabularyName));

      try {
        const payload = yield call(customVocabularyFetchRecord, vocabularyName, token);
        yield put({
          type: MODEL_CUSTOM_VOCABULARY_ADD_RECORD,
          payload,
        });

        yield put(providers.setTerms(payload.terms));
        yield put({ type: VOCABULARY_LIST_DRILLDOWN_SET_VOCABULARY_STATE_LOADED });
      } catch (err) {
        yield put({ type: VOCABULARY_LIST_DRILLDOWN_SET_VOCABULARY_STATE_LOAD_ERROR });
      }
    };
  });

  // note carryover from terminusSaga prob needs reframe

  bottle.factory('terminusDrilldownHandlerAddVocabulary', () => {
    return function* terminusDrilldownHandlerAddVocabulary({ payload }) {
      const [token] = yield select((state) => {
        return [
          _.get(state, 'users.ephemeralKey.bearerToken'),
        ];
      });

      if (token) {
        yield call(customVocabularyAddRecord, payload, token);
        yield put({ type: VOCABULARY_LIST_DRILLDOWN_FETCH_TERM });
      }

      yield put({ type: VOCABULARY_LIST_DRILLDOWN_ADDING_VOCABULARY_RESET });
      yield put({ type: VOCABULARY_LIST_DRILLDOWN_STOP_ADDING_VOCABULARY });
    };
  });

  bottle.factory('terminusDrilldownSetEditingWeight', () => {
    return function* terminusDrilldownSetEditingWeight({ payload: weight }) {
      const [terms, checklist] = yield select((state) => {
        return [
          _.get(state, 'terminusDrilldown.termsEditing'),
          _.get(state, 'terminusDrilldown.termsCheckList'),
        ];
      });
      if (checklist && Array.isArray(checklist) && checklist.length) {
        // eslint-disable-next-line no-param-reassign
        weight = _.clamp((weight && _.isNumber(weight) ? weight : 0), 0, MAX_WEIGHT);

        const newTerms = terms.map((term) => {
          if (!(term.empty || checklist.includes(term.id))) {
            return term;
          }
          const newTerm = term.clone();
          newTerm.weight = weight;
          return newTerm;
        });
        yield put(providers.setEditingTerms(newTerms));
      } else {
        yield put(providers.setEditingTerms(terms));
      }
    };
  });

  bottle.factory('terminusDrilldownResetChecks', () => {
    return function* terminusDrilldownResetChecks() {
      yield put({ type: VOCABULARY_LIST_DRILLDOWN_EDITING_SET_CURRENT_TERM_CHECKLIST, payload: [] });
    };
  });

  bottle.factory('terminusDrilldownHandlerTerminator', () => {
    return function* terminusDrilldownHandlerTerminator() {
      const [vocabularyName, termState, token] = yield select((state) => {
        return [
          _.get(state, 'terminusDrilldown.vocabularyName'),
          _.get(state, 'terminusDrilldown.termState'),
          _.get(state, 'users.ephemeralKey.bearerToken'),
        ];
      });

      if (termState !== VOCABULARY_LIST_DRILLDOWN_VOCABULARY_STATE_LOADED) {
        return;
      }
      if (vocabularyName) {
        yield call(customVocabularyRemoveRecords, [vocabularyName], token);
        yield put({
          type: MODEL_CUSTOM_VOCABULARY_REMOVE_RECORD,
          payload: vocabularyName,
        });
      } else {
        console.log('attempt to delete without name');
      }
    };
  });

  bottle.factory('terminusDrilldownHandlerGetVocabularyAndTerms', () => {
    return function* loadCurrentTermFromVocabularyName() {
      const [vocabularyName] = yield select((state) => {
        return [
          _.get(state, 'terminusDrilldown.vocabularyName'),
        ];
      });

      if (vocabularyName) {
        yield put(providers.fetchVocabulary());
      } else {
        yield put(providers.setTerms([]));
      }
    };
  });

  bottle.factory('terminusDrilldownHandlerSaving', () => {
    return function* () {
      const [vocabularyName, newVocabularyName, terms, token] = yield select((state) => {
        if (_.get(state, 'terminusDrilldown.listIsNew', false)) {
          return [
            '',
            _.get(state, 'terminusDrilldown.currentTermEditedName'),
            _.get(state, 'terminusDrilldown.termsEditing'),
            _.get(state, 'users.ephemeralKey.bearerToken'),
          ];
        }
        return [
          _.get(state, 'terminusDrilldown.vocabularyName'),
          _.get(state, 'terminusDrilldown.currentTermEditedName'),
          _.get(state, 'terminusDrilldown.termsEditing'),
          _.get(state, 'users.ephemeralKey.bearerToken'),
        ];
      });
      const termData = VocabularyListTermObject.listToData(terms);

      if (!(newVocabularyName && termData.length)) {
        alert('your list must have a nonempty name and one or more terms');
        return;
      }

      if (!token) {
        alert('cannot save; please re-log in.');
        return;
      }

      try {
        const update = {
          vocabularyName: newVocabularyName || vocabularyName,
          terms: termData,
        };
        const result = yield call(customVocabularyUpdateRecord, vocabularyName, update, token);
      } catch (err) {
        alert(`cannot update: ${err.message}`);
        console.log('----------- error updating', err);
      }

      try {
        yield put(providers.setCurrentVocabularyNameID(newVocabularyName));
        yield put(providers.fetchVocabulary());
      } catch (err) {
        console.log('error post update:', err);
      }
    };
  });

  /**
   * ensures the empties are weighted properly
   */
  bottle.factory('terminusDrilldownUpdateEditTerms', () => {
    return function* ({ payload }) {
      yield put(providers.setEditingTerms(payload));
    };
  });

  bottle.factory('terminusDrilldownAddVocabularySaga', ({ terminusDrilldownHandlerAddVocabulary }) => {
    return function* terminusDrilldownAddVocabularySaga() {
      yield takeEvery(VOCABULARY_LIST_DRILLDOWN_ADD_NEW_VOCABULARY, terminusDrilldownHandlerAddVocabulary);
    };
  });

  bottle.factory('terminusDrilldownDeleteVocabularySaga', ({ deleteVocabularies }) => {
    return function* terminusDrilldownDeleteVocabularySaga() {
      yield takeEvery(VOCABULARY_LIST_DRILLDOWN_DELETE_CHECKED_TERMS, deleteVocabularies);
    };
  });

  bottle.factory('terminusDrilldownFetchSaga', ({ terminusDrilldownHandlerFetchTerm }) => {
    return function* terminusDrilldownFetchSaga() {
      yield takeEvery(VOCABULARY_LIST_DRILLDOWN_FETCH_TERM, terminusDrilldownHandlerFetchTerm);
    };
  });

  bottle.factory('terminusDrilldownLoadCurrentNameSaga', ({ terminusDrilldownHandlerGetVocabularyAndTerms }) => {
    return function* terminusDrilldownLoadCurrentNameSaga() {
      yield takeEvery(
        [
          VOCABULARY_LIST_DRILLDOWN_SET_CURRENT_VOCABULARY_NAME,
        ],
        terminusDrilldownHandlerGetVocabularyAndTerms,
      );
    };
  });

  bottle.factory('terminusDrilldownTerminatorSaga', ({ terminusDrilldownHandlerTerminator }) => {
    return function* terminate() {
      yield takeLatest(
        VOCABULARY_LIST_DRILLDOWN_EDITING_DESTROY,
        terminusDrilldownHandlerTerminator,
      );
    };
  });

  bottle.factory('terminusDrilldownSaveSaga', ({ terminusDrilldownHandlerSaving }) => {
    return function* terminusDrilldownSaveSaga() {
      yield takeLatest(
        VOCABULARY_LIST_DRILLDOWN_EDITING_SAVE,
        terminusDrilldownHandlerSaving,
      );
    };
  });

  bottle.factory('terminusDrilldownResetChecksSaga', ({ terminusDrilldownResetChecks }) => {
    return function* terminusDrilldownResetChecksSaga() {
      yield takeLatest(
        VOCABULARY_LIST_DRILLDOWN_EDITING_SET_IS_EDITING_VOCABULARY,
        terminusDrilldownResetChecks,
      );
    };
  });

  bottle.factory('terminusDrilldownSetEditingWeightSaga', ({ terminusDrilldownSetEditingWeight }) => {
    return function* terminusDrilldownSetEditingWeightSaga() {
      yield takeEvery(VOCABULARY_LIST_DRILLDOWN_SET_EDIT_VOCABULARY_WEIGHT, terminusDrilldownSetEditingWeight);
    };
  });

  bottle.factory('terminusDrilldownCloneTermsToEditingSaga', ({ terminusDrilldownUpdateEditTerms }) => {
    return function* terminusDrilldownSetEditingWeightSaga() {
      yield takeEvery([
        VOCABULARY_LIST_DRILLDOWN_SET_CURRENT_VOCABULARY_TERMS,
      ], terminusDrilldownUpdateEditTerms);
    };
  });
};

